/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Stack } from '@atlaskit/primitives/compiled';
import Select from '@atlaskit/select';

type Props = {
	label: string;
	name: string;
	id: string;
	isRequired: boolean;
	options: { label: string; value: string }[];
};

export const SelectInput = ({ label, name, id, isRequired, options }: Props): JSX.Element => (
	<Stack space="space.050">
		<Label htmlFor={id}>
			{label}
			{isRequired && <RequiredAsterisk />}
		</Label>
		<Select name={name} inputId={id} isRequired={isRequired} options={options} />
	</Stack>
);
